

import './conversations.component.js';
import './conversations.controller.js';
import './conversations.service.js';

angular
.module('inkfinder')
.config(function($stateProvider, USER_ROLES) {
  $stateProvider
  .state('inkfinder.messages.conversations', {
    url: '/{conversationId:[0-9]{1,100}}',
    views: {
      '@': {
        component: 'inkConversations'
      }
    },
    resolve: {
      $title: () => 'Your conversation',
      data: function(Conversations, Appointment, Project, $transition$) {
        let data = {};
        return Conversations.get($transition$.params().conversationId)
        .then(function(conversation) {
          data.conversation = conversation;
          return Appointment.get(data.conversation.appointment)
          .then(function(appointment) {
            data.appointment = appointment;
            return Project.get(data.appointment.project)
            .then(function(project) {
              data.project = project;
              return data;
            });
          });
        });
      }
    },
    data: {
      authorizedRoles:
      [USER_ROLES.collector, USER_ROLES.operator, USER_ROLES.artist]
    },
    params: {
      conversationId: {dynamic: true}
    },
    bindings: {
      $transition$: '<'
    }
  });
});



// WEBPACK FOOTER //
// ./components/messages/conversations/index.js